var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-content',[_c('v-list-item-title',{domProps:{"innerHTML":_vm._s(_vm.markText(_vm.searchText, _vm.name))}}),(_vm.attrs)?_c('v-list-item-subtitle',{domProps:{"innerHTML":_vm._s(_vm.markText(_vm.searchText, _vm.attrs.join(' || ')))}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }